/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authClusterListInvites } from "../../funcs/authClusterListInvites.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListClusterInvitesRequest$inboundSchema,
};

export const tool$authClusterListInvites: ToolDefinition<typeof args> = {
  name: "auth-cluster-list-invites",
  description: `List cluster invitations`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authClusterListInvites(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
